import http from "../http";


const RolesService = {
    GetPermissionsService: async () => {
        const Permissions = await http.instance.get("/UserRoles/GetPermissions");
        return Permissions.data
    },
    GetRolesWithPermission: async () => {
        const rolesWithPermissions = await http.instance.get("/UserRoles/GetRolesWithPermission");
        return rolesWithPermissions.data
    },
    GetRoles: async () => {
        const roles = await http.instance.get("/UserRoles/GetRoles");
        return roles.data
    },
    AddPermissionRole: async (RoleForm) => {
        const permissionRole = await http.instance.post("/UserRoles/AddPermissionRole", RoleForm)
        return permissionRole.data;
    },
    DeletePermissionRole: async (RoleForm) => {
        const permissionRole = await http.instance.post("/UserRoles/DeletePermissionRole", RoleForm)
        return permissionRole.data;
    }
};
export default RolesService;
